
import React from 'react';
import { useReportes } from './hooks/useReportes';
import ReporteFilters from './components/ReporteFilters';
import ReporteTable from './components/ReporteTable';
import { generatePDF } from './utils/ReportePDF';
import { Printer } from 'lucide-react';
import DashboardLayout from '../../layouts/DashboardLayout';
import { useAuth } from '../../../context/AuthContext';

const ReportesPage = () => {
    const {
        loading,
        error,
        reportData,
        selectedReport,
        setSelectedReport,
        fechaInicio,
        setFechaInicio,
        fechaFin,
        setFechaFin,
        selectedDate,
        setSelectedDate,
        tipoReporte,
        setTipoReporte,
        fetchReport
    } = useReportes();

    const { user } = useAuth();

    const handleGeneratePDF = () => {
        if (!reportData) return;
        
        generatePDF(selectedReport, reportData, {
            fechaInicio,
            fechaFin,
            tipoReporte,
            selectedDate,
            empresaNombre: user?.empresa?.nombre_empresa || user?.Empresa?.nombre_empresa || user?.Empresa?.nombre_comercial || user?.Empresa?.nombre || 'Empresa Genérica',
            usuarioNombre: user?.nombre_usuario || user?.nombres || user?.nombre || 'Usuario'
        });
    };

    // Override fetchReport to use correct Service method for suma-total if not fully handled in hook
    // Hook handles logic, but let's double check 'suma-total' implementation in hook
    // In previous step I added getReporteSumaTotal to AdminService.
    // I need to update the hook to use it? 
    // The hook in previous step had a comment about missing method. 
    // I should probably update the hook to use AdminService.getReporteSumaTotal(selectedDate)
    // But since I cannot edit the hook in this same turn effectively without re-writing it, 
    // I will assume the hook implementation I wrote earlier used a placeholder or needs update.
    // Actually, I wrote the hook to throw error or use placeholder. 
    // I will rewrite the hook quickly to use the new method OR I will handle it here?
    // Better to have the hook clean. 
    // I will re-write the hook file in this turn to ensure it uses the new AdminService method.

    return (
        <DashboardLayout title="Reportes y Estadísticas">
            <div className="space-y-6 animate-fade-in">
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900 tracking-tight">Reportes</h1>
                        <p className="text-sm text-gray-500 mt-1">Generación de reportes operativos y financieros</p>
                    </div>
                </div>

                <ReporteFilters 
                    selectedReport={selectedReport}
                    onReportChange={(e) => setSelectedReport(e.target.value)}
                    selectedDate={selectedDate}
                    onDateChange={(e) => setSelectedDate(e.target.value)}
                    fechaInicio={fechaInicio}
                    onFechaInicioChange={(e) => setFechaInicio(e.target.value)}
                    fechaFin={fechaFin}
                    onFechaFinChange={(e) => setFechaFin(e.target.value)}
                    tipoReporte={tipoReporte}
                    onTipoReporteChange={(e) => setTipoReporte(e.target.value)}
                    onGenerate={fetchReport}
                />

                {error && (
                    <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6">
                        <p className="text-red-700">{error}</p>
                    </div>
                )}

                {loading && (
                    <div className="flex justify-center items-center py-12">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                    </div>
                )}

                {!loading && reportData && (
                    <div className="animation-fade-in-up">
                        <div className="flex justify-end mb-4">
                            <button 
                                onClick={handleGeneratePDF}
                                className="inline-flex items-center px-4 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors shadow-sm"
                            >
                                <Printer className="w-4 h-4 mr-2" />
                                Descargar PDF
                            </button>
                        </div>

                        <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
                            <div className="p-6">
                                <ReporteTable 
                                    data={reportData} 
                                    type={selectedReport}
                                    extraData={{ fechaInicio, fechaFin, tipoReporte, selectedDate }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </DashboardLayout>
    );
};

export default ReportesPage;
